import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class BudgetService {

  constructor(private http: HttpClient) { }

  getBudgets() {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/budget-header', { headers: headers });
  }

  getDetailBudgets(idBudget) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/budget-detail/' + idBudget, { headers: headers });
  }

    retornarEstado(idBudget) {
      const headers = new HttpHeaders()
        .set('Content-type', 'application/json')
        .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
      return this.http.get(Constants.URL_BACKEND + '/budget-retornar/' + idBudget, { headers: headers });
    } 

  transformNumber(toTransform: String) { //recibe numeros previamente transformados a string con to fixed 2
    if (Number(toTransform) > 1000) {
      var decimal = toTransform.split('.')[1];
      var Num = Number(toTransform.split('.')[0]);
      var quotient = Math.floor(Num / 1000);
      var remainder = String(Num % 1000);

      for (let index = remainder.length; index < 3; index++) {
        remainder = '0' + remainder;
      }
      if (Num >= 1000000) {
        var quotient2 = Math.floor(quotient / 1000);
        var remainder2 = String(quotient % 1000);

        for (let i = remainder2.length; i < 3; i++) {
          remainder2 = '0' + remainder2;
        }

        return String(quotient2) + ',' + remainder2 + ',' + remainder + '.' + decimal;
      }

      return String(quotient) + ',' + remainder + '.' + decimal;
    } else {
      return toTransform;
    }

  }

  InsertBudgetBatch(array) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/budget-detail/batch', { data: array }, { headers: headers });
  }

  InsertBudgetHeader(data) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/budget-header', { data: data }, { headers: headers });
  }

  getOneBudget(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/budget-header/' + id, { headers: headers });
  }

  getBudgetDetails(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/budget-detail/budget-header/' + id, { headers: headers });
  }

  getBudgetDetailsNoFact(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/budget-detail-nofact/budget-header/' + id, { headers: headers });
  }

  getBudgetDetailsFactForNotes(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/budget-detail-fact-for-notes/budget-header/' + id, { headers: headers });
  }

  getBudgetsByWorkOrderId(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/work-order/budget-header/' + id, { headers: headers });
  }

  solAprobation(data) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/solicitud-budget', { data: data }, { headers: headers });
  }
  approveBudget(body) {
   
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/solicitud-budget/' + body.budget.id, body, { headers: headers });
  } ///
  approveBudgetClient(body) {
    //console.log('body->', body.id);
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    const params = new HttpParams().set('id', body.id);
    return this.http.put(Constants.URL_BACKEND + '/solicitud-budget-client/' + body.id, body, { headers: headers });
  }
  approveBudgetCuenta(body) {
    //console.log('body->', body.id);
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    const params = new HttpParams().set('id', body.id);
    return this.http.put(Constants.URL_BACKEND + '/solicitud-budget-cuenta/' + body.id, body, { headers: headers });
  }

  getPermission(solicitud_id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/PermisoAprobarSolicitud/' + solicitud_id, { headers: headers });
  }

  getPermissionCuenta(solicitud_id, client_code) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/PermisoAprobarCuenta/' + solicitud_id + '/' + client_code, { headers: headers });
  }

  updateBudget(data) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/budget-header/' + data.id, { data: data }, { headers: headers });
  }

  updateBudgetArray(data) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/budget-header', { data: data }, { headers: headers });
  }

  desactiveBudget(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/budget-header-desactive/' + id, { data: {} }, { headers: headers });
  }

  InsertBudgeAll(array, budgetId) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/budget-detail/all/' + budgetId, { data: array }, { headers: headers });
  }
  
  getDiscountDetails(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/discount-detail/budget-header/' + id, { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/budget.service.ts